import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import AppointmentTable from "../../components/Table/AppointmentTable";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import CustomerTabs from "../../components/CustomerTabs";
import AppointmentModal from "../../components/Modal/AppointmentModal";

import api from "../../../utils/axios";
import Swal from "sweetalert2";

export default function CustomerContactPage() {
  const { id: AR_Id } = useParams();
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);

  const [isAppointModalOpen, setIsAppointModalOpen] = useState(false);
  const [appointmentData, setAppointmentData] = useState(null);
  const [customerData, setCustomerData] = useState(null);

  //  โหลดข้อมูลจาก API
  const fetchData = async () => {
    try {
      setLoading(true);
      const [appointRes, customerRes] = await Promise.all([
        api.get(`/get-appoints/${AR_Id}`),
        api.get(`/get-tb-set-ar1/${AR_Id}`),
      ]);

      //  ดึงข้อมูลนัดหมายทั้งหมด
      const appointList = appointRes.data?.result || [];

      const arData = customerRes.data?.result?.recordset?.[0] || {};

      const latestServiceAddr =
        arData.ServiceAddr_Id || //  จาก get-tb-set-ar1
        (appointList.length > 0 ? appointList[0].ServiceAddr_Id : null);


      setAppointments(appointList);

      //  รวมข้อมูลลูกค้าพร้อม ServiceAddr_Id ล่าสุด
      setCustomerData({
        ...arData,
        AR_Id,
        ServiceAddr_Id: latestServiceAddr,
      });

    } catch (error) {
      console.error("โหลดข้อมูลไม่สำเร็จ:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (AR_Id) fetchData();
  }, [AR_Id]);

  //  เพิ่มนัดหมายใหม่
  const handleAddAppointment = () => {
    const empId = localStorage.getItem("emp_id");
    const empName = localStorage.getItem("name");
    const today = new Date().toISOString().split("T")[0];

    //  ใช้ ServiceAddr_Id จาก customerData หรือจากนัดหมายล่าสุด
    const defaultServiceAddr =
      customerData?.ServiceAddr_Id ||
      (appointments[0] && appointments[0].ServiceAddr_Id) ||
      null;

    setAppointmentData({
      ...defaultForm,
      AR_Id: customerData?.AR_Id || null,
      ServiceAddr_Id: defaultServiceAddr,
      Comp_Id: customerData?.Comp_Id || 1,
      Appoint_Id: null,
      Purpose: "visit",
      Appoint_Date: today,
      Time_Start: "",
      Time_End: "",
      Appoint_Remark: "",
      Sale_Emp_Id: empId,
      Sale_Emp_Name: empName,
      Width: "",
      Length: "",
      Height: "",
      SpecRemark: "", //  เพิ่มฟิลด์นี้
    });

    setTimeout(() => setIsAppointModalOpen(true), 0);
  };

  //  แก้ไขนัดหมาย (ส่งข้อมูลเต็มรวม SpecRemark)
  const handleEdit = (item) => {
    const data = {
      ...item,
      mode: "edit",
      AR_Id: customerData?.AR_Id || null,
      Comp_Id: customerData?.Comp_Id || 1,
      ServiceAddr_Id: item.ServiceAddr_Id || customerData?.ServiceAddr_Id || null,
      Width: item.Width || "",
      Length: item.Length || "",
      Height: item.Height || "",
      SpecRemark: item.SpecRemark || "",
      Sale_Latitude: item.Sale_Latitude || null,
      Sale_Longitude: item.Sale_Longitude || null,
    };

    setAppointmentData(data);
    setIsAppointModalOpen(true);
  };

  const defaultForm = {
    Purpose: "followup",
    Sale_Emp_Id: "",
    Appoint_Date: new Date().toISOString().split("T")[0],
    Time_Start: "",
    Time_End: "",
    Remark: "",
    Width: "",
    Length: "",
    Height: "",
    SpecRemark: "",
    Appoint_Id: null,
  };


  //  ลบนัดหมาย
  const handleDelete = async (item) => {
        try {
          await api.delete(`/delete-appoint/${item.Appoint_Id}`);
          fetchData();
        } catch (error) {
          console.error("ลบข้อมูลไม่สำเร็จ:", error);
          Swal.fire("ผิดพลาด!", "เกิดข้อผิดพลาดในการลบข้อมูล", "error");
        }
  };

  //  บันทึกข้อมูล (สร้าง / แก้ไข)
  const handleSave = async (mode, formData) => {
    try {
      const isFollowup = formData.Purpose === "followup";
      const endpoint = isFollowup ? "/create-call" : "/create-appoint";

      const payload = isFollowup
        ? {
            Comp_Id: formData.Comp_Id,
            AR_Id: formData.AR_Id,
            ServiceAddr_Id: formData.ServiceAddr_Id,
            Sale_Emp_Id: formData.Sale_Emp_Id,
            Call_Date: formData.Appoint_Date,
            Time_Start: formData.Time_Start,
            Time_End: formData.Time_End,
            Call_Remark: formData.Remark || "",
            Call_Type: 2,
          }
        : {
            Purpose: "visit",
            Comp_Id: formData.Comp_Id,
            AR_Id: formData.AR_Id,
            ServiceAddr_Id: formData.ServiceAddr_Id,
            Sale_Emp_Id: formData.Sale_Emp_Id,
            Appoint_Date: formData.Appoint_Date,
            Time_Start: formData.Time_Start,
            Time_End: formData.Time_End,
            Appoint_Remark: formData.Remark || "",
            Width: formData.Width ? Number(formData.Width) : null,
            Length: formData.Length ? Number(formData.Length) : null,
            Height: formData.Height ? Number(formData.Height) : null,
            SpecRemark: formData.SpecRemark?.trim() || "", //  ส่งค่าผลการนัดหมาย
            Latitude: formData.Latitude || null,  //  เพิ่ม
            Longitude: formData.Longitude || null, //  เพิ่ม
          };


      if (formData.Appoint_Id) {
        await api.put(`/update-appoint/${formData.Appoint_Id}`, payload);
      } else {
        await api.post(endpoint, payload);
      }

      // Swal.fire({
      //   icon: "success",
      //   title: "สำเร็จ!",
      //   text: isFollowup
      //     ? "บันทึกการติดต่อลูกค้าเรียบร้อย"
      //     : "บันทึกนัดหมายเรียบร้อย",
      // });

      setIsAppointModalOpen(false);
      setAppointmentData(null);
      fetchData();
    } catch (err) {
      console.error("Save Appointment Error:", err);
      Swal.fire("ผิดพลาด", "ไม่สามารถบันทึกข้อมูลได้", "error");
    }
  };

  if (!customerData) return <p className="p-6">กำลังโหลดข้อมูล...</p>;

  return (
    <div className="flex">
      <Sidebar />
      <main
        className="flex-1 h-screen overflow-auto bg-gray-50 transition-all duration-300"
        style={{ marginLeft: "var(--sidebar-width)" }}
      >
        <Topbar
          breadcrumbs={[
            { label: "ลูกค้า", link: "" },
            { label: "รายการลูกค้า", link: "/sale" },
            { label: "ข้อมูลนัดหมาย" },
          ]}
        />
        <CustomerTabs customer={customerData} />

        <div className="p-8 space-y-8 mt-20">
          {loading ? (
            <p className="text-gray-500">กำลังโหลดข้อมูล...</p>
          ) : (
            <AppointmentTable
              appointments={appointments}
              onAdd={handleAddAppointment}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          )}
        </div>
      </main>

      {/*  Appointment Modal */}
      <AppointmentModal
        key={appointmentData?.Appoint_Id || "create"} //  บังคับ remount เมื่อสร้างใหม่
        isOpen={isAppointModalOpen}
        onClose={() => setIsAppointModalOpen(false)}
        initialData={appointmentData}
        customerData={customerData}
        serviceAddrId={
          appointmentData?.ServiceAddr_Id || customerData?.ServiceAddr_Id
        }
        onSave={handleSave}
        appointLatitude={appointmentData?.Sale_Latitude || null}
        appointLongitude={appointmentData?.Sale_Longitude || null}
      />

    </div>
  );
}
